import * as Immutable from 'seamless-immutable';

import {SET_THUMBNAIL_URL, CLEAR_ALL_THUMBNAILS} from '../actions';

const initialState = Immutable.from({});

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_THUMBNAIL_URL:
      return state.set(action.payload.attachmentUrn, action.payload);
    case CLEAR_ALL_THUMBNAILS:
      return Immutable.from(initialState);
    default:
      return state;
  }
};
